import { HttpErrorResponse } from "@angular/common/http";
import { throwError } from "rxjs";

export class ErrorHandlers {
  static HandleApiError(errorRes: HttpErrorResponse) {
    let errorMessage = "An unknown error occurred!";
    let errorList = [];

    switch (errorRes.status) {
      case 401:
        errorMessage = "Un Authorized";
        break;
      case 400:
        errorList = errorRes.error.error;
        errorMessage = errorRes.error.Message;
        break;
      case 404:
        errorList = errorRes.error.error;
        errorMessage = errorRes.error.Message;
        break;
      case 500:
        errorMessage = "Server Error";

      // console.error("Error : " + JSON.stringify(errorRes.status));
    }

    return throwError(errorRes.error);
  }

  static HandleError(errorResponse: HttpErrorResponse) {
    if (errorResponse.error instanceof ErrorEvent) {
    } else {
    }

    return throwError(errorResponse.error);
  }
}
